import { render, staticRenderFns } from "./leave-type-picker.vue?vue&type=template&id=2094ab7e&scoped=true&"
import script from "./leave-type-picker.vue?vue&type=script&lang=js&"
export * from "./leave-type-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2094ab7e",
  null
  
)

export default component.exports